import { ScratchCardConfig } from './scratch-card.models';

export class ScratchCard {
  canvas: HTMLCanvasElement;
  private context: CanvasRenderingContext2D;
  private config: ScratchCardConfig;
  private isDragging = false;
  private callBackHandled = false;
  private ctx: CanvasRenderingContext2D;
  private element: HTMLElement;
  private eventListeners: { type: string; listener: EventListener }[] = [];

  constructor(cnf: ScratchCardConfig) {
    this.config = cnf;
    this.generateCanvas();
    this.context = this.canvas.getContext('2d') as CanvasRenderingContext2D;
    this.fillCanvas();
  }

  init(): void {
    this.addEventListeners();
  }

  private generateCanvas(): void {
    this.canvas = document.createElement('canvas');
    this.canvas.classList.add(this.config.canvasClass);
    this.canvas.width = this.config.width;
    this.canvas.height = this.config.height;
    this.config.element.appendChild(this.canvas);
  }

  private fillCanvas(): void {
    this.context.fillStyle = this.config.mask;
    this.context.fillRect(0, 0, this.config.width, this.config.height);
  }

  private addEventListeners(): void {
    this.canvas.addEventListener('mousedown', (event) => this.handleDragStart(event));
    this.canvas.addEventListener('mousemove', (event) => this.handleDragMove(event));
    this.canvas.addEventListener('mouseup', () => this.handleDragEnd());
    this.canvas.addEventListener('mouseleave', () => this.handleDragEnd());
  }

  private handleDragStart(event: MouseEvent): void {
    this.isDragging = true;
    this.scratch(event.offsetX, event.offsetY);
  }

  private handleDragMove(event: MouseEvent): void {
    if (this.isDragging) {
      this.scratch(event.offsetX, event.offsetY);
    }
  }

  private handleDragEnd(): void {
    this.isDragging = false;
  }

  private scratch(x: number, y: number): void {
    this.context.globalCompositeOperation = 'destination-out';
    this.context.beginPath();
    this.context.arc(x, y, this.config.zoneRadius, 0, 2 * Math.PI);
    this.context.fill();

    const percent = this.updatePercent();
    if (percent >= this.config.percentToFinish && !this.callBackHandled) {
      this.config.callback();
      this.callBackHandled = true;
    }
  }

  private updatePercent(): number {
    const imageData = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
    let counter = 0;

    for (let i = 0; i < imageData.data.length; i += 4) {
      if (imageData.data[i + 3] === 0) counter++;
    }

    return (counter / (this.canvas.width * this.canvas.height)) * 100;
  }
  private setupEventListeners(): void {
    const onScratch = (e: MouseEvent | TouchEvent) => {
      // Handle scratching logic
    };

    this.canvas.addEventListener('mousedown', onScratch);
    this.canvas.addEventListener('touchstart', onScratch);

    // Store listeners for cleanup
    this.eventListeners.push(
      { type: 'mousedown', listener: onScratch },
      { type: 'touchstart', listener: onScratch }
    );
  }

  private drawMask(): void {
    // Draw the mask on the canvas
    this.ctx.fillStyle = this.config.mask || '#FFCD00';
    this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
  }
  destroy(): void {
    // Remove event listeners
    this.eventListeners.forEach(({ type, listener }) => {
      this.canvas.removeEventListener(type, listener);
    });

    // Remove the canvas from the DOM
    if (this.canvas.parentElement) {
      this.canvas.parentElement.removeChild(this.canvas);
    }
  }

}
